import {Component, Input, OnInit} from '@angular/core';
import {KfRegistration} from '../../../../shared/models/kf-registration.interface';
import {KfRegistrationDetail} from '../../../../kf-data-entry/models/kf-registration-detail.interface';
import {Master} from '../../../../admin/models/master.interface';
import {QuantitativeDetail} from '../../../../kf-data-entry/models/quantitative-detail.interface';

@Component({
  selector: 'app-kf-registration-recycling-validation-table',
  templateUrl: './kf-registration-recycling-validation-table.component.html',
  styleUrls: ['./kf-registration-recycling-validation-table.component.scss']
})
export class KfRegistrationRecyclingValidationTableComponent implements OnInit {

  @Input()
  kfRegistration!: KfRegistration;
  @Input()
  kfRegistrationDetail!: KfRegistrationDetail;
  @Input()
  categories!: Master[];

  displayedColumns: string[] = ['entry', 'mr', 'omr', 'ru', 'er', 'td', 'ld', 'loss', 'total', 'remark'];

  constructor() { }

  ngOnInit(): void {
  }

  getTotalValue(item: QuantitativeDetail): string {
    return this.sum([item.mr, item.ru, item.er, item.td, item.ld, item.loss, item.omr]).toFixed(2);
  }

  sum = (array: number[]) =>  array.reduce((s, v) => s + (v || 0), 0);
}
